import $ from 'jquery';

$('.hamburger, .header-nav__closer').on('click', function () {
    $('.site-header').toggleClass('site-header--active')
    $('.part-header-buttons').toggleClass('part-header-buttons--dark')
    $('.hamburger').toggleClass('hamburger--close')
    $('body').toggleClass('menu-active')
})
